import React from 'react';
import './ColorVault.css';

const ColorVault = ({ colors, onColorChange, disabled = false }) => {
    // Überprüfung, ob colors definiert ist und ein Objekt ist
    const isColorsDefined = colors && typeof colors === 'object';

    const colorLabels = ['Akzent', 'Dunkel BG', 'Dunkel Text', 'Hell Content', 'Hell BG'];

    return (
        <div className={`modern-color-vault ${disabled ? 'disabled' : ''}`}>
            {isColorsDefined && Object.entries(colors).map(([colorKey, colorValue], index) => (
                <div key={colorKey} className="modern-color-item">
                    <div className="modern-color-label">
                        {colorLabels[index] || `Color ${index + 1}`}
                    </div>
                    <div className="modern-color-picker-container">
                        <div 
                            className="modern-color-preview" 
                            style={{ backgroundColor: colorValue }}
                        >
                            <input 
                                id={colorKey}
                                type="color" 
                                name={colorKey}
                                value={colorValue}
                                onChange={(e) => !disabled && onColorChange(colorKey, e.target.value)}
                                className="modern-color-input"
                                disabled={disabled}
                                title={disabled ? 'Use Space Settings to change colors' : 'Change color'}
                            />
                        </div>
                        <div className="modern-color-code">
                            {colorValue.toUpperCase()}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ColorVault;
